import React from 'react'
import CustomTag from 'components/CustomTag'

const DriveStatus = ({ status, offerStatus }) => {
  let colorType
  let tagMessage
  if (status == 'SCHEDULED') {
    colorType = 'grey'
    tagMessage = 'Scheduled'
  } else if (status == 'SHORTLISTED') {
    colorType = 'green'
    tagMessage = 'Shortlisted'
  } else if (status == 'HOLD') {
    colorType = '#F3A66E'
    tagMessage = 'On hold'
  } else if (status == 'REJECTED') {
    colorType = 'red'
    tagMessage = 'Rejected'
  } else if (status == 'SELECTED') {
    colorType =
      offerStatus === 'NOT_RELEASED' || offerStatus === 'ACCEPTED'
        ? 'green'
        : offerStatus === 'REJECTED'
        ? 'red'
        : 'grey'
    tagMessage =
      offerStatus === 'NOT_RELEASED'
        ? 'Selected'
        : offerStatus === 'RELEASED'
        ? 'Offer Released'
        : offerStatus === 'ACCEPTED'
        ? 'Offer Accepted'
        : 'Offer Rejected'
  }
  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default DriveStatus
